// extracted by mini-css-extract-plugin
export default {"confirm-payment":"confirm-payment-module_confirm-payment__u40P1"};